import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import i18n from 'i18n';
import { getAllAFsByFilter } from 'data/accessFunction/accessFunction.actions';
import { fetchCollectionFunctionListByFilter, fetchCollectionFunctionList } from 'data/collectionFunction/collectionFunction.actions';
import { getCollectionFunctionGroupList } from 'data/collectionFunctionGroup/collectionFunctionGroup.actions';
import { handleLogout } from 'data/authentication/authentication.actions';
import ModalDialog, { DONT_CLOSE_ON_SUBMIT } from 'shared/modal/dialog';
import { getCspConfigList } from 'data/cspConfig/cspConfig.actions';
import { isMultitenantEnabled } from 'data/supportedFeatures/supportedFeatures.selectors';
import {
  getAllWarrants,
  getWarrantById,
  createWarrantAndRefresh,
  updateWarrant,
  patchWarrant,
  getTargetById,
  clearErrors,
  updateWarrantAndRefresh,
  setTemplate,
  getWarrantGridSettings,
  putWarrantGridSettings,
  deleteWarrantAndRefresh,
  getAllTemplates,
  getWarrantFormConfig,
  getWarrantFormCustomizationConfig,
  setWarrantTracker,
  clearWarrantTracker,
  setWarrantConfigInstance,
} from './warrant-actions';
import { getUserTeams, getTimezones, getDivisions } from '../../users/users-actions';
import { getAllContacts } from '../../data/contact/contact.actions';
import { getAllCasesByCaseIds } from '../cases/case-actions';
import { getAllTargetsByTargetIds } from '../targets/targets-actions';
import { getDXSettings } from '../discovery-xcipio-actions';
import { fetchLocationList } from '../../data/location/location.actions';
import { getAllAttachments } from '../attachments/attachments-actions';
import ModuleRoutes from './warrant-routes';
import './warrants.scss';

const LOGIN_WARNING_STORAGE_KEY = 'showLoginActivityWarning';

const Warrants = (props: any) => {
  const [isLoginWarningDialogOpen, setIsLoginWarningDialogOpen] = React.useState(false);

  React.useEffect(() => {
    const { displayUserLoginWarning } = props.discoveryXcipio.discoveryXcipioSettings;
    if (props.authentication?.isAuthenticated &&
      displayUserLoginWarning &&
      sessionStorage.getItem(LOGIN_WARNING_STORAGE_KEY) === 'true') {
      setIsLoginWarningDialogOpen(true);
      sessionStorage.removeItem(LOGIN_WARNING_STORAGE_KEY);
    }
  }, [
    props.authentication?.isAuthenticated,
    props.discoveryXcipio.discoveryXcipioSettings.displayUserLoginWarning,
    sessionStorage.getItem(LOGIN_WARNING_STORAGE_KEY)
  ]);

  const handleWarningConfirm = () => {
    setIsLoginWarningDialogOpen(false);
    return DONT_CLOSE_ON_SUBMIT;
  };

  const handleWarningSignOut = () => {
    setIsLoginWarningDialogOpen(false);
  };

  const handleWarningSignOutNow = () => {
    setIsLoginWarningDialogOpen(false);
    props.handleLogout();
    return DONT_CLOSE_ON_SUBMIT;
  };

  const renderLoginWarningDialog = () => (
    <div>
      <p>
        {i18n.t('warrant.loginWarning.message.prefix')}
        {' '}
        <strong>{i18n.t('warrant.loginWarning.message.logOffNow')}</strong>
        {' '}
        {i18n.t('warrant.loginWarning.message.suffix')}
      </p>
      <p>{i18n.t('warrant.loginWarning.message.legal')}</p>
    </div>
  );

  return (
    <>
      <ModalDialog
        title={i18n.t('warrant.loginWarning.title')}
        actionText={i18n.t('warrant.loginWarning.close')}
        closeText={i18n.t('warrant.loginWarning.action')}
        customComponent={renderLoginWarningDialog}
        isOpen={isLoginWarningDialogOpen}
        onClose={handleWarningSignOut}
        onSubmit={handleWarningSignOutNow}
      />
      <ModuleRoutes {...props} />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  warrants: state.warrants,
  cases: state.cases,
  contacts: state.contacts,
  users: state.users,
  authentication: state.authentication,
  global: state.global,
  discoveryXcipio: state.discoveryXcipio,
  isMultitenantEnabled: isMultitenantEnabled(state),
  cspConfigs: state.cspConfig.entities,
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  getAllWarrants,
  getWarrantById,
  createWarrantAndRefresh,
  updateWarrant,
  patchWarrant,
  getAllTargetsByTargetIds,
  getTargetById,
  clearErrors,
  updateWarrantAndRefresh,
  setTemplate,
  getWarrantGridSettings,
  putWarrantGridSettings,
  getUserTeams,
  getCspConfigList,
  getAllContacts,
  getAllCasesByCaseIds,
  fetchCollectionFunctionList,
  fetchCollectionFunctionListByFilter,
  getAllAFsByFilter,
  deleteWarrantAndRefresh,
  getAllTemplates,
  getWarrantFormConfig,
  setWarrantTracker,
  clearWarrantTracker,
  getTimezones,
  getDivisions,
  setWarrantConfigInstance,
  getCollectionFunctionGroupList,
  getWarrantFormCustomizationConfig,
  getDXSettings,
  getAllAttachments,
  fetchLocationList,
  handleLogout,
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Warrants));
